module.exports = __webpack_public_path__ + "static/media/7.2287566a.png";